<template>
  <div>
    <PageHeader :title="title" :items="items">
      <i
        class="bx bxs-help-circle font-size-20 div-clickable"
        @click="iniciarTour()"
      ></i>
    </PageHeader>
    <div>
      <b-card data-v-step="1">
        <div
          class="row"
          v-if="
            this.$store.state.veiculoCooperado.listaVeiculo.length > 1 &&
              !this.$route.query.sq_gerenciamento
          "
        >
          <b-form-group
            label="Veiculo"
            invalid-feedback="campo obrigatório"
            class="col-md-12 mb-3"
          >
            <multiselect
              v-model="veiculoSelected"
              placeholder="Selecione"
              :show-labels="false"
              :options="this.$store.state.veiculoCooperado.listaVeiculo"
              :allow-empty="false"
              @input="inputVeiculo()"
              :custom-label="
                ({ nm_versao, ds_placa }) => `${nm_versao} - [${ds_placa}]`
              "
              data-v-step="2"
            />
          </b-form-group>
        </div>
        <div class="row">
          <b-form-group
            label="Data *"
            class="col-md-3 mb-3"
            :state="state('dtKmParticular')"
          >
            <date-picker
              v-model="dados.dtKmParticular"
              format="DD/MM/YYYY"
              value-type="YYYY-MM-DD"
              :disabled-date="disabledData()"
              :default-value="veiculoSelected.dt_inicial"
              append-to-body
            />
            <span class="text-warning"
              >Período do Veículo:
              {{ $tools.converteData(veiculoSelected.dt_inicial) }} A
              {{ $tools.converteData(veiculoSelected.dt_final) }}</span
            >
          </b-form-group>
          <b-form-group label="KM Inicial *" class="col-md-2 mb-2">
            <b-form-input
              :state="state('kmInicial')"
              v-model="dados.kmInicial"
            />
          </b-form-group>
          <b-form-group label="KM Final *" class="col-md-2 mb-2">
            <b-form-input :state="state('kmFinal')" v-model="dados.kmFinal" />
          </b-form-group>
          <b-form-group label="KM Percorrido" class="col-md-2 mb-2" disabled>
            <b-form-input
              :value="parseInt(dados.kmFinal) - parseInt(dados.kmInicial)"
              disabled
            />
          </b-form-group>
          <div class="col-md-3">
            <b-form-group
              label="Tipo de Lançamento"
              :state="state('usoParticular')"
            >
              <multiselect
                :disabled="
                  !this.$route.query.sq_gerenciamento ||
                    (this.$route.query.sq_lancamento == 'null' &&
                      this.$route.query.sq_lancamento)
                "
                v-model="dados.usoParticular"
                placeholder="Selecione"
                :show-labels="false"
                :allow-empty="false"
                :options="usoParticularOptions"
                label="label"
                track-by="value"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <b-form-group
            label="Observação *"
            label-for="observacao"
            class="col-12 md-3"
          >
            <b-form-textarea
              for="observacao"
              v-model="dados.dsObs"
              placeholder="Observação"
              :maxlength="200"
              :state="state('dsObs')"
            ></b-form-textarea>
            <div class="text-center">
              <p
                v-if="dados.dsObs"
                class="badge position-absolute"
                :class="{
                  'bg-success': dados.dsObs.length !== 200,
                  'bg-warning': dados.dsObs.length === 200
                }"
              >
                {{ dados.dsObs.length }} / 200
              </p>
            </div>
          </b-form-group>
        </div>

        <div class="d-flex justify-content-end px-1 mt-3">
          <div class="me-2 align-self-center mt-1">
            <router-link to="/cooperado/rdv">
              <b-button class="btn-lg"> Voltar </b-button>
            </router-link>
          </div>
          <div class="me-2 align-self-center mt-1" data-v-step="2">
            <b-button
              variant="primary"
              @click="incluirKmParticular()"
              class="m-1 btn-lg"
            >
              Salvar
            </b-button>
          </div>
        </div>
      </b-card>
    </div>
    <v-tour
      name="tourKMparticular"
      :steps="stepsKMparticular"
      :options="tourOptions"
    ></v-tour>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    PageHeader,
    Multiselect
  },
  data() {
    return {
      title: this.$route.query.sq_gerenciamento
        ? "Editar KM Particular"
        : "Novo KM Particular",
      items: [],
      itemFromCrud: null,
      submit: false,
      dados: {
        usoParticular: { label: "Uso Particular", value: "P" },
        dtKmParticular: "",
        kmInicial: 0,
        kmFinal: 0,
        dsObs: ""
      },
      usoParticularOptions: [
        { label: "Uso Particular", value: "P" },
        { label: "Uso a Trabalho", value: "L" }
      ],
      usoParticularOptionsGood: [
        { label: "Uso Particular", value: "P" },
        { label: "Uso a Trabalho", value: "U" }
      ],
      placaVeiculo: "",
      veiculo: {},
      tourOptions: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "Sair",
          buttonPrevious: "Anterior",
          buttonNext: "Próximo",
          buttonStop: "Sair"
        }
      },
      stepsKMparticular: [
        {
          target: '[data-v-step="1"]',
          content: "Para inserir uma novo KM Particular",
          params: {
            placement: "top",
            highlight: true,
            enableScrolling: false
          }
        },
        {
          target: '[data-v-step="2"]',
          content:
            "Clique em Incluir para adicionar a nova despesa ou em Voltar para retornar a tela do geral do RDV",
          params: {
            placement: "bottom",
            highlight: true,
            enableScrolling: false
          }
        }
      ],
      veiculoSelected: {}
    };
  },
  watch: {
    "dados.usoParticular": function(newVal) {
      this.dados.usoParticular.label = this.usoParticularOptions.find(
        option => option.value === newVal.value
      ).label;
    }
  },
  mounted() {
    this.veiculoSelected = this.$store.state.veiculoCooperado.listaVeiculo[0];
  },
  created() {
    this.veiculoSelected = this.$store.state.veiculoCooperado.listaVeiculo[0];
    window.scrollTo(0, 0);
    this.items = [
      {
        text: "RDV Digital",
        href: "/cooperado/rdv",
        active: false
      },
      {
        text: this.veiculoSelected.cd_rdv,
        active: true
      },
      {
        text: "Km Particular",
        active: true
      },
      {
        text: this.veiculoSelected.ds_placa,
        active: true
      }
    ];
    if (this.$route.query.sq_gerenciamento) {
      this.buscarAbastecimento();
    }
  },
  validations: {
    dados: {
      dtKmParticular: {
        required
      },
      kmInicial: {
        required
      },
      kmFinal: {
        required
      }
      // dsObs: {
      //   required,
      // },
    }
  },
  methods: {
    state(param) {
      if (this.submit) {
        return !this.$v.dados[param].$invalid;
      } else {
        return null;
      }
    },
    buscarAbastecimento() {
      if (
        this.veiculoSelected &&
        this.veiculoSelected.cd_rdv &&
        this.$route.query.sq_veiculo &&
        this.$route.query.sq_gerenciamento &&
        this.$route.query.sq_lancamento
      ) {
        this.$http
          .get(
            "api/telemetria/buscarAbastecimento/" +
              this.veiculoSelected.cd_rdv +
              "/" +
              this.$route.query.sq_veiculo +
              "/" +
              this.$route.query.sq_gerenciamento
          )
          .then(response => {
            var abastecimento = response.data;
            this.dados.dtKmParticular = abastecimento.dt_gerenciamento;
            this.dados.kmInicial = abastecimento.qt_km_inicial;
            this.dados.kmFinal = abastecimento.qt_km_final;
            this.dados.dsObs = abastecimento.ds_obs;
            if (abastecimento.ds_origem == "Good Card") {
              this.dados.usoParticular = this.usoParticularOptionsGood.find(
                el => el.value == abastecimento.st_origem
              );
            } else {
              this.dados.usoParticular = this.usoParticularOptions.find(
                el => el.value == abastecimento.st_origem
              );
            }
          });
      }
    },
    incluirKmParticular() {
      var sqGerenciaciamento = this.$route.query.sq_gerenciamento;
      this.submit = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (
        parseInt(this.dados.kmFinal.trim()) -
          parseInt(this.dados.kmInicial.trim()) <=
        0
      ) {
        this.$tools.alerta("Km percorrido menor ou igual a 0", "error");
        return;
      }
      this.$http
        .post("api/rdvCooperado/veiculo/incluirKmParticular", {
          cd_rdv: this.veiculoSelected.cd_rdv,
          sq_veiculo:
            this.$route.query.sq_veiculo ?? this.veiculoSelected.sq_veiculo,
          sq_gerenciamento: sqGerenciaciamento ? sqGerenciaciamento : null,
          dt_gerenciamento: this.dados.dtKmParticular,
          qt_km_inicial: this.dados.kmInicial,
          qt_km_final: this.dados.kmFinal,
          ds_obs: this.dados.dsObs,
          p_tp_km: this.dados.usoParticular.value
            ? this.dados.usoParticular.value
            : "P",
        })
        .then(() => {
          this.$store.commit("ENVIAR_NOTIFICACAO", {
            notificacao: "Cadastro com sucesso",
            icone: "success"
          });
          this.$router.push("/cooperado/rdv");
        })
        .catch(err => {
          this.$tools.alerta(err.response.data.message, "error");
        });
    },
    disabledData() {
      var dataInicio = this.veiculoSelected.dt_inicial
        .replace(/[-]/g, " ")
        .split(" ");
      var dataFim = this.veiculoSelected.dt_final
        .replace(/[-]/g, " ")
        .split(" ");
      return date =>
        date < new Date(dataInicio[0], dataInicio[1] - 1, dataInicio[2]) ||
        date > new Date(dataFim[0], dataFim[1] - 1, dataFim[2]);
    },
    iniciarTour() {
      this.$tours["tourKMparticular"].start();
    },
    inputVeiculo() {
      this.dados.kmInicial = this.veiculoSelected.qt_km_final;
    }
  }
};
</script>
